import { SaveDraftConfirmationModal } from "./Modal";
import { EmailSaveDraftConfirmationModalProps } from "./types";
import { confirmable, createConfirmation } from "../../../hooks/DialogMountPoint";

export function openEmailSaveChangesConfirmation(form: MailMessage) : Promise<boolean> {
    return createConfirmation<EmailSaveDraftConfirmationModalProps, boolean>(confirmable(SaveDraftConfirmationModal))({
        dialogId: 'confirm_email_save_changes_modal',
        defaultValues: form
    });
};